import { render } from "./PodcastCardSkeleton.vue?vue&type=template&id=06c0dfea&scoped=true"
const script = {}

import "./PodcastCardSkeleton.vue?vue&type=style&index=0&id=06c0dfea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c0dfea"]])

export default __exports__